module.exports = __webpack_public_path__ + "img/channel.f6fadc15.png";